import Vue from 'vue'
import VueI18n from 'vue-i18n'

import zh from './zh'
import en from './en'
import locale from 'element-ui/lib/locale'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

Vue.use(VueI18n);
const messages = {
  en: Object.assign(en, enLocale),
  zh: Object.assign(zh, zhLocale),
  //   en: Object.assign(en),
  //   zh: Object.assign(zh),
}
const i18n = new VueI18n({
  locale: sessionStorage.getItem('lang') || 'en',
  messages
});
// 为了实现element插件的多语言切换
locale.i18n((key, value) => i18n.t(key, value));

export default i18n;



// WEBPACK FOOTER //
// ./src/lang/index.js